import { AwaitResponse } from "@/utils/MockUtils";
import AbstractServices from "./AbstractServices";

export default class ServicesMock extends AbstractServices {
  static getIpsiUrls() {
    const response = {
      '@odata.context': 'https://dhldev02.crm6.dynamics.com/api/data/v9.1/$metadata#dhl_configurations(dhl_name,dhl_value)',
      value: [
        {
          '@odata.etag': 'W/"134170610"',
          dhl_value:
            'https://simulation-api.enterprisesecure.com.au/es-client-frontend/embedded?userName=dhl.iframe.demo&configId=dcbfdb9c-ace6-4b17-9b4b-df219bbb97bf&amount=1.00&onlyTokenise=true&verifyMessage=3a09a20a95e556039216810af22f309693987d4206d08cddbac582bb92390725',
          dhl_name: 'IpsiLongTermTokenURL',
          dhl_configurationid: '28b999fc-9b0f-f011-998a-000d3ae1185d',
        },
        {
          '@odata.etag': 'W/"134170598"',
          dhl_value:
            'https://simulation-api.enterprisesecure.com.au/es-client-frontend/embedded?tokenControl.tokenLifeTime=15&tokenControl.tokenUsageLimit=1&userName=dhl.iframe.demo&configId=9fbc136a-ee2b-4c07-bd38-19f458abe881&amount=1.00&onlyTokenise=true&verifyMessage=6677d75995b584d73e3f37e15403b353a197231f5976fc6deb5a68cbcd3c0530',
          dhl_name: 'IpsiShortTermTokenURL',
          dhl_configurationid: 'fd36aa23-9c0f-f011-998a-000d3ae1185d',
        },
      ],
    };

    return AwaitResponse(
      {
        "shortTermTokenUrl": response.value.find(urlObj => { return urlObj.dhl_name === 'IpsiShortTermTokenURL'; }).dhl_value,
        "longTermTokenUrl": response.value.find(urlObj => { return urlObj.dhl_name === 'IpsiLongTermTokenURL'; }).dhl_value,
      });
  }

  static getPremiumAdjustmentPricesCRM() {
    return AwaitResponse({
      "prorataPrice": 99,
      "policyCrn": "testCRN123",
      "standardPremiumPaymentAmount": 120,
      "nextContributionDate": "2025-11-12",
      "futureContributionDate": "2025-12-26",
      "frequency": "fortnightly"
    });
  }

  static raiseWorkItemCRM() {
    return AwaitResponse({
      "@odata.context": "https://dhldev02.crm6.dynamics.com/api/data/v9.2/$metadata#Microsoft.Dynamics.CRM.dhl_CreateworkitemResponse",
      "output": "Work item created with id 079a4695-6abb-ee11-9078-000d3ae1a81f"
    });
  }

  static uploadRebateFormPdfCRM() {
    return AwaitResponse({
      "@odata.context": "https://dhldev02.crm6.dynamics.com/api/data/v9.1/$metadata#Microsoft.Dynamics.CRM.dhl_SaveRebateFormResponse",
      "responseString": "{\r\n  \"StorageContainer\": \"documents\",\r\n  \"FileName\": \"ProductGuideLink.pdf\",\r\n  \"ETAG\": \"\\\"0x8DCB6C972292CAF\\\"\",\r\n  \"BlobName\": \"1099625/rebateForms/ProductGuideLink.pdf\"\r\n}",
      "errorMessage": null
    });
  }
}